
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ListPage extends Vue {
  @Prop({ default: 0 }) private total!: number;
  @Prop({ default: 1 }) private index!: number;
  @Prop({ default: 10 }) private size!: number;
  @Prop({ default: true }) private showElevator!: boolean;
  @Prop({ default: true }) private showSizer!: boolean;
  @Prop({ default: "bottom" }) private placement!: boolean;
  public pageChange(val: number): void {
    this.$emit("change", val);
  }
  public pageSizeChange(val: number): void {
    this.$emit("size-change", val);
  }
}
